import { setURL } from '@/api/apiUtil'

export default {
  // 取得公告類別清單
  getCommunityCategories: {
    url: setURL('/communityCategory'),
    method: 'get'
  },
  // 根據社區編號取得公告列表
  getCommunityNotices: {
    url: (communityId) =>
      setURL('/communityNotice/community/:communityId', { communityId }),
    method: 'get'
  },
  // 取得公告詳細資訊
  getCommunityNoticesById: {
    url: (communityNoticeId) =>
      setURL('/communityNotice/:communityNoticeId', { communityNoticeId }),
    method: 'get'
  },
  // 新增社區公告
  postCommunityNotices: {
    url: setURL('/communityNotice'),
    method: 'post'
  },
  // 編輯社區公告
  putCommunityNotices: {
    url: (communityNoticeId) =>
      setURL('/communityNotice/:communityNoticeId', { communityNoticeId }),
    method: 'put'
  },
  // 刪除社區公告
  deleteCommunityNoticeId: {
    url: (communityNoticeId) =>
      setURL('/communityNotice/:communityNoticeId', { communityNoticeId }),
    method: 'delete'
  },
  // 社區公告加入排程
  postCommunityNoticesSchedule: {
    url: (communityNoticeId) =>
      setURL('/communityNotice/:communityNoticeId/schedule', {communityNoticeId}),
    method: 'post'
  },
  // 撤除社區公告排程
  deleteCommunityNoticesSchedule: {
    url: (communityNoticeId) =>
      setURL('/communityNotice/:communityNoticeId/cancel-schedule', {communityNoticeId}),
    method: 'delete'
  }
}
